var __assign = (this && this.__assign) || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
import { __decorate } from "tslib";
import { __metadata } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, ViewChild, Input, Output, EventEmitter, } from "@angular/core";
import config from "./config";
import { BasketAssistant } from "@api/services/basket";
import { AppState } from "../../../app.service";
import { classifyOfferTariff } from "@api/utils";
import { TrackingError } from "@api/services/tracking";
import { InfoIComponent } from "app/shared/components/info-i";
import { DateDropdownComponent } from "app/shared/components/date-dropdown";
var MIN_AGE = 18;
var MAX_AGE = 119;
export var PortingType;
(function (PortingType) {
    PortingType["IS_REQUESTED"] = "porting_is_requested";
    PortingType["ULTIMO_DATE"] = "porting_ultimo_date";
    PortingType["ULTIMO_CONTRACT"] = "porting_ultimo_contract";
})(PortingType || (PortingType = {}));
var NumberPortingComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function NumberPortingComponent(appState) {
        var _this = this;
        this.appState = appState;
        this.scrollToErrorMsg = new EventEmitter();
        /**
         * Set our default values
         */
        this.localState = { value: "" };
        this.phoneLines = [];
        this.offers = [];
        this.offersMapped = {};
        this.offersUsed = {};
        this.serviceProviders = [];
        this.showNumberPortingOption = true;
        this.options = [
            {
                inputValue: PortingType.IS_REQUESTED,
                headline: "",
                content: "Das heißt, frühestens 8 Arbeitstage nachdem Ihre Portierungsunterlagen vollständig bei uns sind. Sie können eine Rufnummer nur mitnehmen, wenn die Daten beim alten Anbieter identisch sind.",
                label: "zum nächstmöglichen Termin",
            },
            {
                inputValue: PortingType.ULTIMO_DATE,
                headline: "",
                content: "Das Datum muss mindestens 18 Arbeitstage und darf maximal 123 Kalendertage in der Zukunft liegen. Liegt Ihr Wunschtermin vor dem Vertragsende? Dann bleibt der Vertrag bei Ihrem aktuellen Anbieter von der Rufnummern-Mitnahme unberührt. Er wird zu den alten Konditionen fortgesetzt. Fragen Sie bitte vor Vertragsschluss bei Ihrem bisherigen Anbieter, ob Kosten für Sie entstehen.",
                label: "zum Wunschtermin ",
                date: {
                    headline: "Wunschtermin",
                    minWorkDaysInFuture: 18,
                    maxDaysInFuture: 123,
                    needsToBeWorkDay: true,
                    hasError: false,
                    errorMsg: "Ihr Wunschtermin muss mindestens 18 Arbeitstage, aber höchstens 123 Kalendertage in der Zukunft liegen. Er muss auf einem Arbeitstag liegen.",
                },
            },
            {
                inputValue: PortingType.ULTIMO_CONTRACT,
                headline: "",
                content: "Der Vertrag bei Ihrem bisherigen Anbieter bleibt von der Rufnummern-Mitnahme unberührt. Er wird zu den alten Konditionen fortgesetzt. Fragen Sie bitte vor Vertragsschluss bei Ihrem bisherigen Anbieter, ob Kosten für Sie entstehen.",
                label: "zum Vertragsende",
                date: {
                    headline: "Vertragsende",
                    minDaysInFuture: 0,
                    maxDaysInFuture: 123,
                    maxDaysInPast: 90,
                    hasError: false,
                    errorMsg: "Ihr Kündigungstermin darf nicht mehr als 90 Kalendertage in der Vergangenheit liegen und höchstens 123 Kalendertage in der Zukunft.",
                },
            },
        ];
        /**
         * Form values
         */
        this.numberPorting = "no";
        this.numberPortingType = PortingType.IS_REQUESTED;
        this.phoneLine = "";
        this.phoneNumber = "";
        this.offer = "";
        this.serviceProvider = "";
        this.customerNumber = "";
        this.contractDetails = "identical";
        this.birthDay = "Tag";
        this.birthMonth = "Monat";
        this.birthYear = "Jahr";
        this.street = "";
        this.streetNumber = "";
        this.zipCode = "";
        this.city = "";
        this.nameOrCompany = "";
        this.entries = [];
        /**
         * Error vars
         */
        this.zeroEntriesError = false;
        this.phoneLineError = false;
        this.phoneNumberError = false;
        this.offerError = false;
        this.serviceProviderError = false;
        this.customerNumberError = false;
        this.birthDateError = false;
        this.streetError = false;
        this.streetNumberError = false;
        this.zipCodeError = false;
        this.cityError = false;
        this.nameOrCompanyError = false;
        this.numberPortingDate = "";
        /**
         * helpers
         */
        this.years = [];
        this.days = [];
        this.patterns = {
            NUMERIC: /^\d+$/,
            STRING: /^[a-zA-ZàáâäãåacceèéêëeiìíîïlnòóôöõøùúûüuuÿýzzñçcszÀÁÂÄÃÅACCEEÈÉÊËÌÍÎÏILNÒÓÔÖÕØÙÚÛÜUUYÝZZÑßÇOÆCSZð &!?,‚.:'\-\(\)\/]+$/,
            EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            ALPHANUMERIC: /^\d+[a-zA-Z]*$/,
            STRING_NUMERIC: /^[0-9a-zA-ZàáâäãåacceèéêëeiìíîïlnòóôöõøùúûüuuÿýzzñçcszÀÁÂÄÃÅACCEEÈÉÊËÌÍÎÏILNÒÓÔÖÕØÙÚÛÜUUYÝZZÑßÇOÆCSZ?ð &!?,.:'\-\(\)\/]+$/,
            STRING_NUMERIC_ONLY: /^([0-9a-zA-Z]{6,10})$/,
        };
        BasketAssistant.subscribe("itemsAdded", this.loadOffers.bind(this));
        BasketAssistant.subscribe("itemsDeleted", function () {
            _this.offersUsed = {};
            _this.entries = [];
            _this.loadOffers();
        });
    }
    //callback number porting date event
    NumberPortingComponent.prototype.numberPortingDateChange = function (evt) {
        this.numberPortingDate = evt;
    };
    NumberPortingComponent.prototype.ngOnInit = function () {
        this.phoneLines = config.phoneLines;
        this.serviceProviders = config.serviceProviders;
        this.loadOffers();
        this.buildBirthdateComponent();
    };
    NumberPortingComponent.prototype.buildBirthdateComponent = function () {
        this.years = [];
        var date = new Date();
        date.setFullYear(date.getFullYear() - MIN_AGE);
        for (var i = date.getFullYear(); i > date.getFullYear() - (MAX_AGE - MIN_AGE); i--) {
            this.years.push(i.toString());
        }
        this.onChangeDate();
    };
    NumberPortingComponent.prototype.loadOffers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var basketItems, numberOfDataTariffs, numberTotal, basketItemId, componentLabels, basketItem, _i, _a, component, offerItem;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        basketItems = _b.sent();
                        numberOfDataTariffs = 0;
                        numberTotal = 0;
                        this.offersMapped = {};
                        this.offer = "";
                        for (basketItemId in basketItems) {
                            componentLabels = [];
                            basketItem = basketItems[basketItemId];
                            numberTotal += basketItem.amount;
                            if (classifyOfferTariff(basketItem.offer) === "data") {
                                numberOfDataTariffs += basketItem.amount;
                            }
                            for (_i = 0, _a = basketItem.offer.components; _i < _a.length; _i++) {
                                component = _a[_i];
                                componentLabels.push(component.internalLabel);
                            }
                            offerItem = {
                                label: componentLabels.join(" mit "),
                                id: basketItemId,
                                offer: basketItem.offer,
                                amount: basketItem.amount,
                            };
                            this.offersMapped[basketItemId] = offerItem;
                            if (!this.offersUsed[basketItemId]) {
                                this.offersUsed[basketItemId] = 0;
                            }
                        }
                        this.showNumberPortingOption = numberTotal > numberOfDataTariffs;
                        this.calculateOffers();
                        return [2 /*return*/];
                }
            });
        });
    };
    NumberPortingComponent.prototype.calculateOffers = function () {
        this.offers = [];
        var _loop_1 = function (basketItemId) {
            var item = this_1.offersMapped[basketItemId];
            var alreadyUsed = this_1.entries.filter(function (e) { return e.id === item.id; }).length;
            for (var i = 0; i < item.amount - alreadyUsed; i++) {
                if (classifyOfferTariff(item.offer) !== "data") {
                    var itemClone = JSON.parse(JSON.stringify(item));
                    itemClone.amount = 1;
                    this_1.offers.push(itemClone);
                }
            }
        };
        var this_1 = this;
        for (var basketItemId in this.offersMapped) {
            _loop_1(basketItemId);
        }
    };
    NumberPortingComponent.prototype.onChangeDate = function () {
        var month = parseInt(this.birthMonth, 10);
        var year = parseInt(this.birthYear, 10);
        if (!month) {
            month = 1;
        }
        if (!year) {
            year = new Date().getFullYear();
        }
        var numberOfDays = this.daysInMonth(month, year);
        if (numberOfDays < 25 || !numberOfDays) {
            numberOfDays = 31;
        }
        this.days = [];
        for (var i = 1; i < numberOfDays + 1; i++) {
            this.days.push(i.toString());
        }
    };
    NumberPortingComponent.prototype.daysInMonth = function (month, year) {
        return new Date(year, month, 0).getDate();
    };
    NumberPortingComponent.prototype.submitForm = function () {
        var validation = this.validate();
        if (validation) {
            this.onNumberPortingSubmit({
                numberPorting: this.numberPorting,
                numberPortingType: this.numberPorting === "yes" ? this.numberPortingType : "",
                numberPortingDay: this.numberPortingDate.split(".")[0],
                numberPortingMonth: this.numberPortingDate.split(".")[1],
                numberPortingYear: this.numberPortingDate.split(".")[2],
                phoneLine: this.phoneLine,
                phoneNumber: this.phoneNumber,
                offer: this.offer,
                serviceProvider: this.serviceProvider,
                customerNumber: this.customerNumber,
                contractDetails: this.contractDetails,
                birthDay: this.birthDay,
                birthMonth: this.birthMonth,
                birthYear: this.birthYear,
                street: this.street,
                streetNumber: this.streetNumber,
                zipCode: this.zipCode,
                city: this.city,
                nameOrCompany: this.nameOrCompany,
                entries: this.entries,
            });
        }
        else {
            this.scrollToErrorMsg.emit();
        }
    };
    NumberPortingComponent.prototype.validate = function () {
        this.resetValidator();
        var errors = 0;
        var tracking = new TrackingError();
        if (this.numberPorting === "no") {
            return true;
        }
        if (this.numberPortingType === PortingType.ULTIMO_CONTRACT ||
            this.numberPortingType === PortingType.ULTIMO_DATE) {
            if (this.numberPortingDate === "") {
                errors++;
                tracking
                    .setType("validation")
                    .setMessage("Number porting: no date provided")
                    .setLocation("checkout")
                    .track();
            }
        }
        if (this.phoneNumber.length >= 6 && this.phoneNumber.length <= 8) {
            this.addEntry();
        }
        if (this.entries.length === 0) {
            errors++;
            this.zeroEntriesError = true;
            tracking
                .setType("validation")
                .setMessage("Number porting: No entries specified")
                .setLocation("checkout")
                .track();
        }
        if (this.serviceProvider.length < 1 ||
            this.serviceProvider.length > 50) {
            errors++;
            this.serviceProviderError = true;
            tracking
                .setType("validation")
                .setMessage("Number porting: Invalid service provider")
                .setLocation("checkout")
                .track();
        }
        if (!this.patterns.STRING_NUMERIC.test(this.customerNumber) ||
            this.customerNumber.length < 2 ||
            this.customerNumber.length > 50) {
            errors++;
            this.customerNumberError = true;
            tracking
                .setType("validation")
                .setMessage("Number porting: Invalid customer number")
                .setLocation("checkout")
                .track();
        }
        if (this.contractDetails === "different") {
            if (!this.patterns.NUMERIC.test(this.birthDay) ||
                !this.patterns.NUMERIC.test(this.birthMonth) ||
                !this.patterns.NUMERIC.test(this.birthYear)) {
                errors++;
                this.birthDateError = true;
                tracking
                    .setType("validation")
                    .setMessage("Number porting: Invalid birth date")
                    .setLocation("checkout")
                    .track();
            }
            if (!this.patterns.STRING_NUMERIC.test(this.nameOrCompany) ||
                this.nameOrCompany.length < 1 ||
                this.nameOrCompany.length > 50) {
                errors++;
                this.nameOrCompanyError = true;
                tracking
                    .setType("validation")
                    .setMessage("Number porting: Invalid company name")
                    .setLocation("checkout")
                    .track();
            }
            if (!this.patterns.STRING_NUMERIC.test(this.street) ||
                this.street.length < 1 ||
                this.street.length > 50) {
                errors++;
                this.streetError = true;
                tracking
                    .setType("validation")
                    .setMessage("Number porting: Invalid street")
                    .setLocation("checkout")
                    .track();
            }
            if (!this.patterns.STRING_NUMERIC.test(this.streetNumber) ||
                this.streetNumber.length === 0) {
                errors++;
                this.streetNumberError = true;
                tracking
                    .setType("validation")
                    .setMessage("Number porting: Invalid street number")
                    .setLocation("checkout")
                    .track();
            }
            if (!this.patterns.NUMERIC.test(this.zipCode) ||
                this.zipCode.length < 5 ||
                this.zipCode.length > 5) {
                errors++;
                this.zipCodeError = true;
                tracking
                    .setType("validation")
                    .setMessage("Number porting: Invalid zipcode")
                    .setLocation("checkout")
                    .track();
            }
            if (!this.patterns.STRING_NUMERIC.test(this.city) ||
                this.city.length < 2 ||
                this.city.length > 50) {
                errors++;
                this.cityError = true;
                tracking
                    .setType("validation")
                    .setMessage("Number porting: Invalid city")
                    .setLocation("checkout")
                    .track();
            }
        }
        return errors === 0;
    };
    NumberPortingComponent.prototype.resetValidator = function () {
        this.zeroEntriesError = false;
        this.serviceProviderError = false;
        this.customerNumberError = false;
        this.birthDateError = false;
        this.streetError = false;
        this.streetNumberError = false;
        this.zipCodeError = false;
        this.cityError = false;
        this.nameOrCompanyError = false;
    };
    NumberPortingComponent.prototype.addEntry = function (event) {
        var _this = this;
        if (event) {
            event.preventDefault();
        }
        this.resetEntryValidator();
        var tracking = new TrackingError();
        var errors = 0;
        if (!this.patterns.NUMERIC.test(this.phoneLine) ||
            this.phoneLine.length === 0) {
            errors++;
            this.phoneLineError = true;
            tracking
                .setType("validation")
                .setMessage("Number porting: Invalid phone line")
                .setLocation("checkout")
                .track();
        }
        if (!this.patterns.NUMERIC.test(this.phoneNumber) ||
            this.phoneNumber.length < 6 ||
            this.phoneNumber.length > 8) {
            errors++;
            this.phoneNumberError = true;
            tracking
                .setType("validation")
                .setMessage("Number porting: Invalid phone number")
                .setLocation("checkout")
                .track();
        }
        if (this.entries.findIndex(function (entry) {
            return entry.phoneNumber === _this.phoneLine + _this.phoneNumber;
        }) > -1) {
            errors++;
            this.phoneNumberError = true;
            tracking
                .setType("validation")
                .setMessage("Number porting: MSISDN already used")
                .setLocation("checkout")
                .track();
        }
        if (this.offer.length === 0) {
            errors++;
            this.offerError = true;
            tracking
                .setType("validation")
                .setMessage("Number porting: Invalid offer")
                .setLocation("checkout")
                .track();
        }
        if (errors > 0) {
            return;
        }
        var index = this.offers.findIndex(function (offer) { return _this.offer == offer.id; });
        var offerSelected = this.offers[index];
        this.offers.splice(index, 1);
        var entry = __assign({}, offerSelected, { phoneNumber: this.phoneLine + this.phoneNumber });
        this.offersUsed[this.offer] += 1;
        this.entries.push(entry);
        this.offer = "";
        this.phoneLine = "";
        this.phoneNumber = "";
    };
    NumberPortingComponent.prototype.removeEntry = function ($event, entryRemoved) {
        $event.preventDefault();
        var match = -1;
        match = this.entries.findIndex(function (entry) { return entry.id == entryRemoved.id; });
        this.offers.push(this.entries[match]);
        if (match > -1) {
            this.entries.splice(match, 1);
            this.offersUsed[entryRemoved.id] -= 1;
        }
    };
    NumberPortingComponent.prototype.resetEntryValidator = function () {
        this.phoneLineError = false;
        this.phoneNumberError = false;
        this.offerError = false;
    };
    return NumberPortingComponent;
}());
export { NumberPortingComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/checkout-form/number-porting/number-porting.component.ts
// module id = null
// module chunks = 